import React from "react";
import ModelRouteMap from "./ModelRouteMap";  // Import the modal component
// import RouteMap from "./Routemap";            // Import the route map component
import { useRouteNameChanges } from "../../feature/RouteNameProvider";
const RouteMapPage = () => {
  const { driverState,setDriverState } =
  useRouteNameChanges();
  // Manage driverState here in the parent component
  // const [driverState, setDriverState] = useState({
  //   driver: null,
  //   route_name: "",
  // });

  return (
    <div>
      {/* Pass driverState and setDriverState as props to ModelRouteMap */}
      <ModelRouteMap driverState={driverState} setDriverState={setDriverState} />

      {/* Pass driverState to RouteMap */}
      {/* <RouteMap driverState={driverState} setDriverState={setDriverState} /> */}
    </div>
  );
};

export default RouteMapPage;
